import $ from 'jquery'

var listHover = function() {

  $('a.collab').hover(function () {
      //Hover in
      var image_class = $(this).attr('data-project');
      var image = $('.' + image_class);
      if(image.length > 0)
      {
          image.addClass('active');
      }
  }, function () {
      //Hover out
      var image_class = $(this).attr('data-project');
      var image = $('.' + image_class);
      if(image.length > 0)
      {
          image.removeClass('active');
      }
  });

}

module.exports = listHover;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/list-hover.js